// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { BoomHomeContext } from '../../contexts/BoomHomeContext';
import { selectBoomHasPendingNotifications } from '../../selectors/notifications.selector';
import { selectBoomCurrentStepId } from '../../selectors/steps.selector';
import { selectBoomUserNbWonSteps, selectBoomUserProgressAllIsCompleted } from '../../selectors/user.selector';

import BoomHome from './BoomHome';

type BoomHomeContainerProps = {
  className?: string;
};

const BoomHomeContainer = (ownProps: BoomHomeContainerProps) => {
  const currentStepId = useSelector(selectBoomCurrentStepId);
  const nbWonSteps = useSelector(selectBoomUserNbWonSteps);
  const isCompleted = useSelector(selectBoomUserProgressAllIsCompleted);
  const hasPendingNotifications = useSelector(selectBoomHasPendingNotifications);

  const boomHomeContextValue = useMemo(
    () => ({
      currentStepId,
      nbWonSteps,
    }),
    [currentStepId, nbWonSteps],
  );

  const selectedProps = useMemo(
    () => ({
      isCompleted: isCompleted && !hasPendingNotifications,
    }),
    [hasPendingNotifications, isCompleted],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return (
    <BoomHomeContext.Provider value={boomHomeContextValue}>
      <BoomHome {...enhancedProps} />
    </BoomHomeContext.Provider>
  );
};

export default BoomHomeContainer;
